// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__ttm0i","title":"style_title__pAW42","description":"style_description__ojiFh","image":"style_image__vKKs8","btn":"style_btn__e0C6a"};